import React, {FC} from "react";
import {useField} from "formik";
import {DateTimePicker} from "@material-ui/pickers";

interface FormikDateSelectProps {
    name: string;
    label: string;
    disablePast?: boolean;
}

export const FormikDateSelect: FC<FormikDateSelectProps> = ({label, name, disablePast = true}) => {
    const [, meta, helpers] = useField<number | null>(name);

    return (
        <DateTimePicker
            cancelLabel={"Zurück"}
            error={meta.touched && Boolean(meta.error)}
            helperText={meta.touched && meta.error}
            label={label}
            fullWidth
            minutesStep={15}
            disablePast={disablePast}
            ampm={false}
            format={'dd.MM.yyyy - HH:mm'}
            value={meta.value}
            onChange={(date) => {
                if (date) {
                    helpers.setValue(date.getTime());
                }
            }}
        />
    )
}
